<template>
  <div class="container">
    <h1>用户设备配置</h1>
    <button class="save-btn" @click="saveConfig">保存配置</button>

    <div
      v-for="(devices, user) in config"
      :key="user"
      class="user-section"
    >
      <h3>{{ user }}</h3>
      <ul class="device-list">
        <li
          v-for="(device, index) in devices"
          :key="device"
          class="device-item"
          style="align-items: flex-start;"
        >
          <span class="device-id" style="min-width: 120px; display: inline-block;">{{ device }}</span>
          <button class="delete-btn" @click="removeDevice(user, index)">删除</button>
        </li>
      </ul>
      <div class="input-row">
        <input
          v-model="newDevice[user]"
          placeholder="添加设备ID"
          class="device-input"
        />
        <button class="add-btn" @click="addDevice(user)">添加设备</button>
      </div>
    </div>
  </div>
</template>

<script>
import { showSuccess, showError } from '../utils';
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://relia-server.com:3000',
  timeout: 10000,
  withCredentials: true,
});

export default {
  name: "UserDeviceConfig",
  data() {
    return {
      config: {},
      newDevice: {},
    };
  },
  created() {
    this.fetchConfig();
  },
  methods: {
    async fetchConfig() {
      try {
        const response = await axiosInstance.get('/api/device-access');
        this.config = response.data;
        this.newDevice = {};
        for (const user in this.config) {
          this.newDevice[user] = "";
        }
        showSuccess("加载用户设备配置成功");
      } catch (err) {
        showError("加载配置失败: " + err.message);
      }
    },
    addDevice(user) {
      // 如果输入为空，弹窗提示
      if (!this.newDevice[user] || this.newDevice[user].trim() === "") {
        showError("设备ID不能为空！");
        return;
      }
      const id = this.newDevice[user] ? this.newDevice[user].trim() : "";
      if (id && !this.config[user].includes(id)) {
        this.config[user].push(id);
        this.newDevice[user] = "";
      }
    },
    removeDevice(user, index) {
      this.config[user].splice(index, 1);
    },
    async saveConfig() {
      try {
        await axiosInstance.post('/api/save-device-access', this.config);
        showSuccess("保存成功！");
      } catch (err) {
        showError("保存失败: " + err.message);
      }
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  margin-bottom: 10px;
  color: #333;
}

.save-btn {
  display: block;
  margin: 0 auto 30px;
  padding: 10px 30px;
  font-size: 16px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.save-btn:hover {
  background-color: #0056b3;
}

.user-section {
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  padding: 15px 20px;
  margin-bottom: 25px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

h3 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #555;
}

.device-list {
  list-style: none;
  padding-left: 0;
  margin: 0 0 10px;
}

.device-item {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.device-id {
  font-size: 16px;
  color: #002366;
}

.delete-btn {
  padding: 6px 12px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 8px;
}

.delete-btn:hover {
  background-color: #c82333;
}

.input-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.device-input {
  width: 200px;
  padding: 6px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.add-btn {
  padding: 6px 14px;
  font-size: 14px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.add-btn:hover {
  background-color: #0056b3;
}
</style>
